module.exports = ".single-box ul {\n  margin-bottom: 15px; }\n\n@media (min-width: 800px) {\n  .single-box li {\n    font-size: 16px; } }\n\n.past-scholarship {\n  list-style: none;\n  margin: 0; }\n\n@media (min-width: 800px) {\n    .past-scholarship {\n      -webkit-column-count: 2;\n         -moz-column-count: 2;\n              column-count: 2;\n      max-width: 575px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/scholarship/scholarship.component.scss
// module id = ./src/app/scholarship/scholarship.component.scss
// module chunks = main